import { useMemo } from 'react'
import { getFlightSearchInsuranceQuoteKey } from 'lib/insurance/insuranceFlights'
import CFMRUnforseenEventsModalContent from 'components/Insurance/UnforseenEventsModal/CFMRUnforseenEventsModalContent'
interface Props {
  destinationCountry: string
  departingDate: string
  arrivalDate: string
  occupants: App.Occupants
  insuranceQuotes?: Record<string, App.InsuranceQuote>
  insuranceQuote?: App.InsuranceQuote
  cfmrUnforeseenEventsCost?: number
}

function CFMRUnforeseenEventsModalContent({ destinationCountry, departingDate, arrivalDate, occupants, cfmrUnforeseenEventsCost, insuranceQuotes, insuranceQuote }: Props) {
  const quote = useMemo(() => {
    if (insuranceQuote) return insuranceQuote

    if (!cfmrUnforeseenEventsCost || !insuranceQuotes) return

    const quoteKey = getFlightSearchInsuranceQuoteKey(
      departingDate,
      arrivalDate,
      cfmrUnforeseenEventsCost,
      destinationCountry,
      occupants,
    )

    return insuranceQuotes[quoteKey]
  }, [arrivalDate, departingDate, destinationCountry, occupants, insuranceQuotes, cfmrUnforeseenEventsCost, insuranceQuote])

  return <CFMRUnforseenEventsModalContent quote={quote} />
}

export default CFMRUnforeseenEventsModalContent
